import { Typography } from "@material-tailwind/react";
import FAQComponent from "./FAQComponent";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

function CalculationToolsFAQsComponent() {
    const { t } = useTranslation();
    const faqs = [
        {
            id: "1",
            question: t("WhatIsCalculationToolsSoftware"),
            answer: t("WhatIsCalculationToolsSoftwareAnswer"),
        },
        {
            id: "2",
            question: t("WhoCanBenefitFromUsingCalculationTools"),
            answer: t("WhoCanBenefitFromUsingCalculationToolAnswer"),
        },
        {
            id: "3",
            question: t("HowDoesCalculationToolsEnsureAccurateHeatLoadCalculations"),
            answer: t("HowDoesCalculationToolsEnsureAccurateHeatLoadCalculationsAnswer"),
        },
        {
            id: "4",
            question: t("IsCalculationToolsCompatibleWithDifferentBuildingTypes"),
            answer: t("IsCalculationToolsCompatibleWithDifferentBuildingTypesAnswer"),
        },
        {
            id: "5",
            question: t("CanIModifyParametersOnceAProjectIsStarted"),
            answer: t("CanIModifyParametersOnceAProjectIsStartedAnswer"),
        },
        {
            id: "6",
            question: t("WhatStandardsDoesCalculationToolsAdhereTo"),
            answer: t("WhatStandardsDoesCalculationToolsAdhereToAnswer"),
        },
        {
            id: "7",
            question: t("HowDoesCalculationToolsContributeToEnergyEfficiencyInSeatingSystems"),
            answer: t("HowDoesCalculationToolsContributeToEnergyEfficiencyInSeatingSystemsAnswer"),
        },
        {
            id: "8",
            question: t("WhatKindOfSupportAndUpdatesCanUsersExpect"),
            answer: t("WhatKindOfSupportAndUpdatesCanUsersExpectAnswer"),
        },
    ];

    // Generate FAQ structured data
    const faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqs.map((faq) => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.answer,
            },
        })),
    };

    return (
        <>
            <Helmet>
                <script type="application/ld+json">
                    {JSON.stringify(faqSchema)}
                </script>
            </Helmet>
            <div className="bg-#F6F6F6 pb-[50px]">
                <Typography variant="h2" className="uppercase text-lg 2xl:text-3xl font-bold tracking-[0.9px] text-center py-[30px] lg:py-[60px]">
                    {t("FAQ")}
                </Typography>
                <div className="mx-[20px] lg:mx-[100px] flex flex-col gap-[15px]">
                    {faqs.map((faq) => (
                        <FAQComponent key={faq.id} faq={faq} />
                    ))}
                </div>
            </div>
        </>
    );
}

export default CalculationToolsFAQsComponent;
